import { api } from '../api';

export const authService = {
  login: (email: string, password: string) =>
    api.post('/users/login', { email, password }),

  register: (data: {
    name: string;
    email: string;
    password: string;
    phone: string;
    cpf_or_rg: string;
    birth_date: string;
    role: 'admin' | 'organizer' | 'customer';
  }) => api.post('/users/register', data),

  forgotPassword: (email: string) =>
    api.post('/auth/forgot-password', { email }),
};